/**
 增值服务
 */
import React, { Component } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XSelect, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import model from '@/reducers/operation/service/model';
import SetRate from './modal/SetRate';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Service extends Component {

    static propTypes = {
        history: PropTypes.object, // 路由history对象
        match: PropTypes.object,
        setBreadcrumbPaths: PropTypes.func,
        getServiceList: PropTypes.func,
        serviceList: PropTypes.object,
        getStatusEnum: PropTypes.func,
        statusEnum: PropTypes.array,
    }

    static defaultProps = {
        serviceList: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 },
        statusEnum: []
    }

    state = {
        modal: false,
        modalParam: {},
        serviceName: '',
        statusItem: {},
    }

    componentDidMount() {
        const { getStatusEnum, setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match);
        getStatusEnum({ enumName: 'GoodsStateEnum' });
    }

    _searchHandle = (useCache) => {
        const { pageNum, pageSize, serviceName, statusItem } = this.state;
        let query = {
            serviceName,
            status: statusItem.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getServiceList(query);
        KeepAlive.saveCache({ ...query, statusItem }); // 【第3步，缓存查询状态】
    }

    _resetHandle = () => {
        this.setState({
            serviceName: '',
            statusItem: {},
            startDate: null,
            endDate: null
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    ///请求
    _request = (url, data, tip) => {
        http(url, data, 'POST')
            .then(res => {
                this._searchHandle('useCache');
                message.success(tip);
            })
            .catch(err => message.error(err.message));
    }

    // 表格操作
    _tableAction = (type, values) => {
        switch (type) {
            case 'detail':
                this._jumpPage('增值服务详情', `/detail/${values.extraServiceId}`);
                break;
            case 'edit':
                this._jumpPage('编辑增值服务', `/edit/${values.extraServiceId}`);
                break;
            case 'rate':
                this.setState({ modal: true, modalParam: { id: values.extraServiceId } });
                break;
        }
    }

    //路由跳转
    _jumpPage = (title, url) => {
        const { history } = this.props;
        const baseUrl = '/home/operation/service';
        history.push({ pathname: `${baseUrl}${url}` });
    }


    // 渲染弹窗
    _renderModal = () => {
        const { modal, modalParam } = this.state;
        if (modal) {
            return <SetRate data={modalParam} closeModal={this._closeModal} areaChange={this._areaChange} />;
        } else {
            return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ modal: '', modalParam: {} }, () => {
            if (update) this._searchHandle('useCache');
        });
    }

    render() {
        const { serviceName, statusItem } = this.state;
        const { serviceList, statusEnum } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 调用查询接口初始化数据
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='服务名称'
                                placeholder='请输入服务名称'
                                value={serviceName}
                                bindThis={this}
                                bindName='serviceName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='状态'
                                placeholder='请选择状态'
                                renderData={statusEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={statusItem.value}
                                bindThis={this}
                                bindName='statusItem'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent
                        renderData={serviceList}
                        request={this._request}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange} />
                    {this._renderModal()}
                </div>
            </KeepAlive>
        );
    }
}
export default connect((state) => ({
    serviceList: state.operationService.serviceList,
    statusEnum: state.operationService.statusEnum,
}), {
    ...model.actions,
    setBreadcrumbPaths
})(Service);